import { takeLatest } from 'redux-saga/effects'
import * as actions from './version.actions'
import { checkVersionSaga } from './sagas/check-version'

export default function* () {
  yield takeLatest(actions.CHECK_VERSION_REQUEST, checkVersionSaga)
}
